import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INCREASE_KNOWLEDGE_TEST: MijnRoute = {
    path: 'hypotheken-verhogen/kennistoets',
    navigationEvent: 'toHypothekenVerhogenKennistoets',
    regex: /^\/hypotheek\/hypotheken-verhogen\/kennistoets$/,
    webcomponent: 'mijn-hypotheken-verhogen-webcomponent',
    internalPath: 'hypotheken-verhogen/kennistoets'
};
